import { Container, Stack, Title, Text } from '@mantine/core';
import { termsVersions } from '@practist/components';

const Terms = () => {
  const latest = termsVersions[termsVersions.length - 1];
  if (!latest) {
    return (
      <Container size='md' py='xl'>
        <Text c='dimmed'>Terms of Service are not available.</Text>
      </Container>
    );
  }

  return (
    <Container size='md' py='xl'>
      <Stack gap='lg'>
        <div>
          <Title order={1}>{latest.title}</Title>
          <Text size='sm' c='dimmed' mt={4}>
            Version {latest.versionNumber} · Effective {latest.effectiveDate}
          </Text>
        </div>
        <div>{latest.content}</div>
      </Stack>
    </Container>
  );
};

export default Terms;
